/**
 *
 * LoadingContainer
 *
 */
import React, { memo, useEffect, useMemo } from 'react';
import { LoadingContainerWrapper } from './styled';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

interface Props {
  loading?: boolean;
  isFullPage?: boolean;
  description?: string;
  children?: React.ReactNode;
  minHeight?: string;
}

export const LoadingContainer = memo(
  ({
    loading = false,
    isFullPage,
    description = '',
    children,
    minHeight,
  }: Props) => {
    const antIcon = useMemo(
      () => <LoadingOutlined style={{ fontSize: 24 }} spin />,
      [],
    );
    return (
      <LoadingContainerWrapper
        minHeight={minHeight}
        className={isFullPage ? 'fullpage' : ''}
      >
        <Spin indicator={antIcon} tip={description} spinning={loading}>
          {children}
        </Spin>
      </LoadingContainerWrapper>
    );
  },
);
